import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';

export const selectNews = ({ news }) => news;

export const selectAndSortNews = createSelector(
    [selectNews],
    news => sortBy(news.items, elem => elem.active_from).reverse(),
);

const getAlias = (_, alias) => alias;

export const selectNewsWisoutAlias = createSelector(
    [selectNews, getAlias],
    (news, alias) => {
        const items = get(news, 'items', []);
        return items.filter(item => item.alias !== alias).slice(0, 3);
    },
);

export const selectNewsByAlias = createSelector(
    [selectNews, getAlias],
    (news, alias) => {
        const items = get(news, 'itemsByAlias', []);
        return items.find(item => item.alias === alias);
    },
);
